import { Component, Type, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonTextarea } from '@ionic/angular';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
} from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyIonicModule } from '@ngx-formly/ionic';
import { FormlyFieldProps } from '@ngx-formly/ionic/form-field';
import { FormlyFieldTextArea } from '@ngx-formly/ionic/textarea';
import { FocusableMixin } from '@ts/shared/form/focus/util-core';

export interface FormlyTextAreaFieldConfig extends FormlyFieldConfig<FormlyFieldProps> {
  type: 'textarea' | Type<FormlyFieldTextArea>;
}

@Component({
  selector: 'ts-textarea-field',
  styleUrls: ['./textarea-field.component.scss'],
  templateUrl: './textarea-field.component.html',
  imports: [
    IonicModule,
    FormlyIonicModule,
    FormlySelectModule,
    ReactiveFormsModule,
  ],
})
export class TextAreaFieldComponent
  extends FieldType<FieldTypeConfig<FormlyFieldProps>>
  implements FocusableMixin
{
  @ViewChild(IonTextarea) ionTextArea!: IonTextarea;

  setFocus() {
    this.ionTextArea.setFocus();
  }
}
